import { render, staticRenderFns } from "./faturalistesi.vue?vue&type=template&id=35bcac87&"
import script from "./faturalistesi.vue?vue&type=script&lang=js&"
export * from "./faturalistesi.vue?vue&type=script&lang=js&"
import style0 from "./faturalistesi.vue?vue&type=style&index=0&id=35bcac87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports